import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ActivityStatusForm from '../../../components/forms/ActivityStatusForm';
import { useActivityStatusById, useUpdateActivityStatus } from '../../../hooks/useActivityStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ActivityStatusDTO } from '../../../services/apiClient';

const ActivityStatusEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: entityData, isLoading } = useActivityStatusById(id);
  const updateMutation = useUpdateActivityStatus();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Activity Statuses', href: '/admin/activitystatuses' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/activitystatuses');
    } catch (error) {
      console.error('Error updating ActivityStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/activitystatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ActivityStatus.Edit"
    >
        {entityData ? (
          <ActivityStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/activitystatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ActivityStatusEdit;
